/**
 * Memory Cache for NextAuth Session
 * 
 * This module stores the access token in memory (RAM) to avoid calling getSession() 
 * multiple times across different API requests, thereby preventing performance overhead.
 * The token lives in the browser's memory and is destroyed when the tab is closed.
 */

let memoryAccessToken: string | null = null;

export const setMemoryToken = (token: string | null) => {
    memoryAccessToken = token;
};

export const getMemoryToken = (): string | null => {
    return memoryAccessToken;
};
